import React, { useEffect, useState } from 'react';
import Styled from '../AdminGestaoPaginasPage.styled';
import { ComentarioGestaoAdmin } from 'models/recursos-costumizados/ComentariosRecursosCostumizados';
import AdminRecursosCostumizados from 'core/http/service/admin/AdminRecursosCostumizados.service';
import Badge from 'components/badge/Badge';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import eyeIcon from '../../../images/admin/eye.svg';
import CommentModal from './CommentModal';
import Select, { SelectOptionType } from 'components/Select';
import AdminPagination from 'pages/admin/components/pagination/AdminPagination';
import AdminSwitch from 'pages/admin/components/switch/AdminSwitch';
import { cloneDeep } from 'lodash';
import LocalidadeDTO from 'models/perfil/LocalidadeDTO';
import { ProfileService } from 'core/http/service/Profile.service';
import { ResumoRecursoCustomizado } from 'models/recursos-costumizados/ResumoRecursoCustomizado';
import './recurso.css';
import { PaginaIntermediariaService } from 'core/http/service/PaginaIntermediaria.service';
import Loading from 'components/Loading';


const profileService = new ProfileService();
const adminRecursoCostumizadosService = new AdminRecursosCostumizados();
const adminPaginaIntermediariaService = new PaginaIntermediariaService();

const CommentaryGestaoDePaginas = () => {
    const [loading, setLoading] = useState<boolean>(false);
    const [recursoComentario, setRecursoComentario] = useState<ComentarioGestaoAdmin[]>([]);
    const [showIdItemModal, setShowIdItemModal] = useState(-1);
    const [page, setPage] = useState<number>(1);
    const [totalPages, setTotalPages] = useState(1);
    const [filterResponse, setFilterResponse] = useState('');
    const [isLoadingCities, setIsLoadingCities] = useState(false);

    const [cidades, setCidades] = useState<LocalidadeDTO[]>([]);
    const [estados, setEstados] = useState<any[]>([]);
    const [estadoSelected, setEstadoSelected] = useState<string>('');
    const [cidadeSelected, setcidadeSelected] = useState<any>();
    const [coursesItens, setCoursesItens] = useState<ResumoRecursoCustomizado[]>([]);
    const [coursesItensSelected, setCoursesItensSelected] = useState<any>();

    const [pages, setPages] = useState<any[]>([]);
    const [pageSelected, setPageSelected] = useState<any>();
    const [emailFilter, setEmailFilter] = useState<string>('');
    const [ordem, setOrdem] = useState('');
    const [cleanKey, setCleanKey] = useState(0);
    const [totalItems, setTotalItems] = useState(0);
    const [filtroComment, setFiltroComment] = useState('');

    const changePage = (page: number) => {
        setPage(page);
    };

    const answeredFilter: SelectOptionType[] = [
        {
            label: 'Selecione',
            value: '',
        },
        {
            label: 'Respondido',
            value: 'true',
        },
        {
            label: 'Não Respondido',
            value: 'false',
        },
    ];

    const orderOptions: SelectOptionType[] = [
        {
            label: 'Selecione',
            value: '',
        },
        {
            label: 'Nome da página',
            value: 't.nome_pagina:asc',
        },
        {
            label: 'Nome do conteúdo',
            value: 'rc.nome:asc',
        },
        {
            label: 'Mais recentes',
            value: 'data_criacao:desc',
        },
    ];

    interface IFiltro {
        dataInicio: Date | null;
        dataFim: Date | null;
    }
    const [filtroDatas, setFiltro] = useState<IFiltro>({
        dataInicio: null,
        dataFim: null,
    });

    const service = new AdminRecursosCostumizados();

    const fetchComentarios = async (filtro?: string, respondido?: string | undefined, ordem?: string | undefined) => {
        setLoading(true);
        const { data } = await service.getAllComments(
            page,
            filtro ?? filterResponse,
            respondido,
            coursesItensSelected,
            estadoSelected,
            cidadeSelected?.label,
            emailFilter,
            pageSelected
        );
        setTotalPages(data.totalPages);
        setRecursoComentario(data.rows);
        setTotalItems(data.range);
        setLoading(false);
    };

    const fetchAllPagesRecursos = async () => {
        const { data, status } = await adminPaginaIntermediariaService.listar('3');

        if (status === 200) {
            setPages(data);
        }
    };

    const enableComment = async (idx: number) => {
        const clone = cloneDeep(recursoComentario);
        clone[idx].ativo = !clone[idx].ativo;
        const { data } = await service.habilitarComentario(clone[idx].codigo, { comentario: clone[idx].comentario, ativo: clone[idx].ativo });
        setRecursoComentario(clone);
    };

    const loadCidadesPorUf = async () => {
        try {
            setCidades([]);
            setcidadeSelected(null);
            setIsLoadingCities(true);
            const response: any = await profileService.consultarCidadesPorUF(estadoSelected);
            const _cidades: LocalidadeDTO[] = response.data.map((item: any) => new LocalidadeDTO().fromJSON(item));
            setCidades(_cidades);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoadingCities(false);
        }
    };

    const getListCoursesItem = async () => {
        const { data, status }: any = await adminRecursoCostumizadosService.buscarListaResumidaItemAll();

        if (status === 200) {
            setCoursesItens(data);
        }
    };

    useEffect(() => {
        loadCidadesPorUf();
    }, [estadoSelected]);

    const loadEstados = async () => {
        const { data, status } = await profileService.findAllEstados();

        if (status === 200) {
            setEstados(data);
        }
    };

    useEffect(() => {
        loadEstados();
        fetchComentarios();
        getListCoursesItem();
        fetchAllPagesRecursos();
    }, []);

    useEffect(() => {
        fetchComentarios(filtroComment, filterResponse, ordem);
    }, [filtroComment]);

    useEffect(() => {
        fetchComentarios();
    }, [filtroDatas]);

    useEffect(() => {
        fetchComentarios();
    }, [page]);

    useEffect(() => {
        fetchComentarios();
    }, [estadoSelected, cidadeSelected, coursesItensSelected, emailFilter, pageSelected]);

    return (
        <>
            <CommentModal
                show={showIdItemModal != -1}
                onHide={() => setShowIdItemModal(-1)}
                comment={recursoComentario.find(i => i.codigo == showIdItemModal)}
                updateData={() => fetchComentarios('', filterResponse)}
            />
            <div style={{ display: 'flex', maxWidth: '1440px', flexWrap: 'wrap' }}>
                <Styled.Column>
                    <span className="label-order">Respondido</span>
                    <span className="span-select">
                        <Select
                            width="200px"
                            isSmall={true}
                            itens={answeredFilter}
                            onSelected={o => {
                                fetchComentarios('', o.value.toString() ?? '');
                                setFilterResponse(o.value.toString() ?? '');
                            }}
                        />
                    </span>
                </Styled.Column>
                <Styled.Column>
                    <span className="label-order">Página</span>
                    <span className="span-select">
                        <Select
                            style={{ width: '200px' }}
                            placeholder="Selecione"
                            isSmall={true}
                            onSelected={value => setPageSelected(value.value)}
                            itens={[
                                { label: 'Selecione', value: '' },
                                ...(pages?.map((dados: any) => ({
                                    value: dados.codigo,
                                    label: dados.nome,
                                })) || []),
                            ]}
                        />
                    </span>
                </Styled.Column>
                <Styled.Column>
                    <span className="label-order">Item</span>
                    <span className="span-select">
                        <Select
                            style={{ width: '200px' }}
                            placeholder="Selecione"
                            isSmall={true}
                            onSelected={value => setCoursesItensSelected(value.value)}
                            itens={[
                                { label: 'Selecione', value: '' },
                                ...(coursesItens
                                    ?.filter(i => (pageSelected != '' ? i.codigoPaginaIntermediaria === pageSelected : i))
                                    .map((dados: any) => ({
                                        value: dados.codigo,
                                        label: dados.nome,
                                    })) || []),
                            ]}
                        />
                    </span>
                </Styled.Column>
                <Styled.Column>
                    <span className="label-order">Estado</span>
                    <span className="span-select">
                        <Select
                            style={{ width: '200px' }}
                            placeholder="Selecione"
                            isSmall={true}
                            onSelected={value => setEstadoSelected(value.value.toString())}
                            itens={[
                                { label: 'Selecione', value: '' },
                                ...(estados.map((dados: any) => ({
                                    value: dados.id,
                                    label: dados.nome,
                                })) || []),
                            ]}
                        />
                    </span>
                </Styled.Column>
                <Styled.Column>
                    <span className="label-order">Cidade</span>
                    <span className="span-select">
                        <Select
                            disabled={cidades?.length === 0 || isLoadingCities}
                            placeholder="Selecione"
                            style={{ width: '178px' }}
                            isSmall={true}
                            value={{ label: cidadeSelected?.label, value: cidadeSelected?.value }}
                            onSelected={value => setcidadeSelected(value)}
                            itens={[
                                { label: 'Selecione', value: '' },
                                ...(cidades?.map(dados => ({ label: dados.nome, value: dados.id })) || []),
                            ]}
                        />
                    </span>
                </Styled.Column>
                <Styled.Column>
                    <span className="label-order">Email</span>
                    <span className="span-select">
                        <input
                            type="text"
                            style={{ width: '320px', height: '40px', borderRadius: '5px', border: '1px solid #bfbfbf' }}
                            placeholder="Digite o email"
                            defaultValue={emailFilter}
                            onBlur={e => setEmailFilter(e.target.value)}
                        />
                    </span>
                </Styled.Column>
            </div>
            <Styled.TableGrid>
                <Styled.TableGridHead>
                    <Styled.TableGridHeadCell>Nome do Item</Styled.TableGridHeadCell>
                    <Styled.TableGridHeadCell>Nome do conteúdo</Styled.TableGridHeadCell>
                    <Styled.TableGridHeadCell>Autor</Styled.TableGridHeadCell>
                    <Styled.TableGridHeadCell>E-mail</Styled.TableGridHeadCell>
                    <Styled.TableGridHeadCell>Data</Styled.TableGridHeadCell>
                    <Styled.TableGridHeadCell>Respondido</Styled.TableGridHeadCell>
                    <Styled.TableGridHeadCell>Data</Styled.TableGridHeadCell>
                    <Styled.TableGridHeadCell>Ações</Styled.TableGridHeadCell>
                </Styled.TableGridHead>
                {!loading ? (
                    <>
                        {recursoComentario.map((comentario, idx) => {
                            return (
                                <Styled.TableGridRow key={comentario.codigo}>
                                    <Styled.TableGridCell>{comentario.nomeItem}</Styled.TableGridCell>
                                    <Styled.TableGridCell>{comentario.nomeConteudo}</Styled.TableGridCell>
                                    <Styled.TableGridCell>{comentario.nomeUsuario}</Styled.TableGridCell>
                                    <Styled.TableGridCell>
                                        {comentario.email ?? (comentario.nomeUsuario === 'humane' && 'adminestruturante@gmail.com')}
                                    </Styled.TableGridCell>
                                    <Styled.TableGridCell>
                                        <Badge color={comentario.respostaAdmin ? '#229645' : '#D64545'}>
                                            {comentario.respostaAdmin ? 'Sim' : 'Não'}
                                        </Badge>
                                    </Styled.TableGridCell>
                                    <Styled.TableGridCell>
                                        {new Date(comentario.dataCriacao).toLocaleDateString('pt-BR', {
                                            day: '2-digit',
                                            month: '2-digit',
                                            year: 'numeric',
                                        })}
                                    </Styled.TableGridCell>
                                    <Styled.TableGridCell>
                                        <OverlayTrigger
                                            overlay={<Tooltip id={'tooltip-action-view_' + comentario.codigo}>Visualizar</Tooltip>}
                                            placement={'top'}
                                        >
                                            <span>
                                                <Styled.ViewButton
                                                    style={{ marginRight: '5px' }}
                                                    src={eyeIcon}
                                                    onClick={() => setShowIdItemModal(comentario.codigo)}
                                                />
                                            </span>
                                        </OverlayTrigger>
                                        <OverlayTrigger
                                            overlay={
                                                <Tooltip id={'tooltip-action-edit_' + comentario.codigo}>
                                                    {`${comentario.ativo ? 'Desabilitar ' : 'Habilitar '}`}
                                                    publicação do comentário
                                                </Tooltip>
                                            }
                                            placement={'top'}
                                        >
                                            <span>
                                                <AdminSwitch value={comentario.ativo} onChange={() => enableComment(idx)} />
                                            </span>
                                        </OverlayTrigger>
                                    </Styled.TableGridCell>
                                </Styled.TableGridRow>
                            );
                        })}
                    </>
                ) : (
                    <><Loading /></>
                )}
            </Styled.TableGrid>
            <AdminPagination onChangePage={changePage} total={totalPages} />
        </>
    );
};

export default CommentaryGestaoDePaginas;
